import Vue from 'vue';
import Component from 'vue-class-component';
import { globals } from '@returns-centre/globals';
import { helpers } from '@/helpers';
import { alertService } from '@returns-centre/services';

@Component
export class RouteMixin extends Vue {
    goToDashboard() {
        this.$router.push({ name: 'Dashboard' });
    }
}

@Component
export class FormatDateMixin extends Vue {
    formatDate(date: string, dateFormat: string) {
        return helpers.formatDate(date, dateFormat);
    }
}

@Component
export class AuthMixin extends Vue {

    get ['$hasLoggedInUser'](): boolean {
        return !!globals.logged_in_customer_id;
    }

    get ['$loggedInUser'](): ReturnsPortalShopifyCustomer|null {
        return globals.logged_in_customer_id
            ? globals.shopify_customer
            : null;
    }
}


@Component
export class RecievesAlertsMixin extends Vue {
    alertMessage: string | null = null;
    alertDisplaying: boolean = false;
    alertIsError: boolean = false;
    alertCallback: ((e: AlertEvent) => void) | null = null;

    //    alertListener = () => this.updateAlert();
    created() {
        this.alertCallback = (e) => this.updateAlert(e);
        alertService.$on('change', this.alertCallback);
        this.updateAlert({
            data: {
                message: alertService.message,
                displaying: alertService.displaying,
                error: alertService.error,
            },
        });
    }
    beforeDestroy() {
        if (this.alertCallback) {
            alertService.$off('change', this.alertCallback);
        }
    }
    updateAlert(e: AlertEvent) {
        this.alertMessage = e.data.message;
        this.alertDisplaying = e.data.displaying;
        this.alertIsError = e.data.error;
    }

}

